import { css } from '@emotion/react';
import { isolateComponent, labelStyles } from '@zapier/style-encapsulation';
import { ServiceIcon } from '../ServiceIcon';
import { ServiceIconConfig } from '../ServiceIcon/constants';
import { ServiceIconNumeric } from './ServiceIconNumeric';
const Styles = labelStyles('ServiceIcons', {
    root: (iconSpacing) => css `
    display: inline-grid;
    user-select: none;
    grid-gap: ${iconSpacing}px;
    grid-auto-flow: column;
  `,
});
export const ServiceIcons = ({ ariaLabel, hasBorder = true, hasWhiteBackground = false, maxServices = 6, renderServiceIcon, services, size = 40, }) => {
    const props = {
        ariaLabel,
        hasBorder,
        services,
        hasWhiteBackground,
        maxServices,
        renderServiceIcon,
        size,
    };
    const { spacing } = ServiceIconConfig[size];
    const label = ariaLabel || `${services.length} apps mentioned`;
    const hasExtraServices = services.length > maxServices;
    const numServicesHidden = hasExtraServices
        ? services.length - maxServices + 1
        : 0;
    const numServicesShown = hasExtraServices ? maxServices - 1 : services.length;
    let visibleServices = [];
    if (numServicesShown === 1) {
        visibleServices = [services[0]];
    }
    else if (numServicesShown >= 2) {
        visibleServices = [
            ...services.slice(0, numServicesShown - 1),
            services[services.length - 1],
        ];
    }
    const icons = visibleServices.map((service, idx) => (isolateComponent("li", { key: idx }, renderServiceIcon ? (renderServiceIcon(service, props)) : (isolateComponent(ServiceIcon, { hasBorder: hasBorder, hasWhiteBackground: hasWhiteBackground, serviceName: service.name, size: size, src: service.src })))));
    if (hasExtraServices) {
        const hiddenServicesCountIcon = (isolateComponent("li", { key: `remainder-${numServicesHidden}` },
            isolateComponent(ServiceIconNumeric, { size: size, number: numServicesHidden, hasBorder: hasBorder, hasWhiteBackground: hasWhiteBackground })));
        if (maxServices > 2)
            icons.splice(-1, 0, hiddenServicesCountIcon);
        else
            icons.push(hiddenServicesCountIcon);
    }
    return (isolateComponent("ul", { "aria-label": label, css: Styles.root(spacing) }, icons));
};
//# sourceMappingURL=ServiceIcons.js.map
// @zapier/design-system@6.27.0 (617a97f69)
